import { createContext } from 'react';

import { BroadcastChannelState } from './broadcast-channel.model';

export const BroadcastChannelContext = createContext<BroadcastChannelState | undefined>(undefined);

BroadcastChannelContext.displayName = 'BroadcastChannelContext';
